module.exports = __webpack_public_path__ + "img/topBg.74d9ec28.png";